import { namespace } from 'wsm-tagging-utils';

const runGMAdobeLaunchEventHandler = (win) => {
	namespace(win, 'DDC.tracking.adobe_launch.handlers');

	const {
		DDC: { tracking },
		com
	} = win;

	tracking.adobe_launch.handlers.GMAdobeLaunchEventHandler = class extends (
		tracking.adobe_launch.handlers.AdobeLaunchEventHandler
	) {
		constructor(window, page, form) {
			super(window, page, form);
			this.logCategory = 'ws-tagging:GMAdobeLaunchEventHandler';
			this.log = com.dealer.log.Logger.createFor(this);
			this.defaultTemplateStrings = {
				// Only US/Canada, so only North American region
				pageRegion: 'na',
				region: 'GMNA'
			};
		}
	};
};

export default runGMAdobeLaunchEventHandler;
